import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import {
  isComparableviyv6ctzm76u as isComparable,
  isInterface3d6p8outrmvmk as isInterface,
} from '../js/typeCheckUtils.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../js/compareTo.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../ComparatorJs.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function compareValuesBy(a, b, selectors) {
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(selectors.length > 0)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException().o2(toString(message));
  }
  return compareValuesByImpl(a, b, selectors);
}
function compareValues(a, b) {
  if (a == null)
    return b == null ? 0 : -1;
  if (b == null)
    return 1;
  return compareTo((!(a == null) ? isComparable(a) : false) ? a : THROW_CCE(), b);
}
function naturalOrder() {
  var tmp = NaturalOrderComparator_instance;
  return isInterface(tmp, Comparator()) ? tmp : THROW_CCE();
}
function compareValuesByImpl(a, b, selectors) {
  var inductionVariable = 0;
  var last = selectors.length;
  while (inductionVariable < last) {
    var fn = selectors[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var v1 = fn(a);
    var v2 = fn(b);
    var diff = compareValues(v1, v2);
    if (!(diff === 0))
      return diff;
  }
  return 0;
}
var NaturalOrderComparatorClass;
function NaturalOrderComparator() {
  if (NaturalOrderComparatorClass === VOID) {
    class $ {
      bn(a, b) {
        return compareTo(a, b);
      }
      compare(a, b) {
        var tmp = (!(a == null) ? isComparable(a) : false) ? a : THROW_CCE();
        return this.bn(tmp, (!(b == null) ? isComparable(b) : false) ? b : THROW_CCE());
      }
    }
    initMetadataForObject($, 'NaturalOrderComparator', VOID, VOID, [Comparator()]);
    NaturalOrderComparatorClass = $;
  }
  return NaturalOrderComparatorClass;
}
var NaturalOrderComparator_instance;
function NaturalOrderComparator_getInstance() {
  return NaturalOrderComparator_instance;
}
//region block: init
NaturalOrderComparator_instance = new (NaturalOrderComparator())();
//endregion
//region block: exports
export {
  compareValuesBy as compareValuesBy2ycqeh37x2wfm,
  compareValues as compareValues1n2ayl87ihzfk,
  naturalOrder as naturalOrder3459ca049ngp6,
};
//endregion

//# sourceMappingURL=Comparisons.mjs.map
